import { FDealType, FOfferType, isAvailable } from 'shared/common/packages/JsonQuery';

import { PosessorContainer } from '../../containers/filters/PosessorContainer';
import { IFilter } from '../../types/filters';

export const posessor: IFilter = {
  availability: isAvailable(FDealType.Any, FOfferType.Any),
  component: PosessorContainer,
};
